module.exports = {"phase":{"G1":["Basement","0","1","2","3","4","5","6","7","Roof"],"G2":["Basement","0","1","2","3","4","5","6","7","Roof"],"G3":["Basement","0","1","2","3","4","5","6","7","Roof"],"H1":["Basement","0","1","2","3","4","5","6","7","8","9","10","11","12","13","14","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31","Roof"],"H2":["Basement","0","1","2","3","4","5","6","7","8","Roof"],"H3":["Basement","0","1","2","3","4","5","6","7","8","Roof"],"Site Wide":["Other (specify below)"],"Completed Area (Estates)":["Other (specify below)"]}}


//////////////////
// WEBPACK FOOTER
// ./src/data/chelseaCreek.json
// module id = 113
// module chunks = 0